var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, ValidateNested } from 'class-validator';
import { BaseFilter, TextFilter, SelectFilter, MultipleFilter, BoolFilter, SearchFilter, MultipleSearchFilter, TimeRangeFilter, } from './filter.entity';
export class FiltersResponse {
}
__decorate([
    IsNotEmpty(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => BaseFilter, {
        discriminator: {
            property: 'type',
            subTypes: [
                { value: TextFilter, name: 'text' },
                { value: SelectFilter, name: 'select' },
                { value: MultipleFilter, name: 'multiple' },
                { value: BoolFilter, name: 'bool' },
                { value: SearchFilter, name: 'search' },
                { value: MultipleSearchFilter, name: 'multiple-search' },
                { value: TimeRangeFilter, name: 'timerange' },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    __metadata("design:type", Array)
], FiltersResponse.prototype, "filters", void 0);
